import querystring from 'querystring';
import request from '@/request';

function appendParams(api, params) {
  if (params) {
    const qs = `?${querystring.stringify(params)}`;
    api += qs;
  }
  return api;
}

export default {
  get(api, params) {
    api = appendParams(api, params);
    return request.get(api);
  },
  getBlob(api, params) {
    api = appendParams(api, params);
    return request({
      method: 'get',
      url: api,
      responseType: 'blob',
    });
  },
  post(api, params, body) {
    api = appendParams(api, params);
    return request.post(api, body);
  },
  postBlob(api, params, body) {
    api = appendParams(api, params);
    return request({
      method: 'post',
      url: api,
      data: body,
      responseType: 'blob',
    });
  },
  put(api, params, body) {
    api = appendParams(api, params);
    return request.put(api, body);
  },
  delete(api, params, body) {
    api = appendParams(api, params);
    return request.delete(api, { data: body });
  },
};
